import { getCurrencySymbol, getLocaleCurrencyCode } from '@angular/common';
import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { COUNTRY_CODE } from '@core/enums';

@Injectable()
export class CurrencyService {
  code = '';
  withDecimals = false;
  currency = '';
  symbol = '';
  symbolNoPrice = '';
  currencyModel: currencyModel = new currencyModel();

constructor(@Inject(LOCALE_ID) private locale: string) { }

  getCurrencyCode(country: string) {
    getLocaleCurrencyCode(this.locale);
    switch (country) {
      case COUNTRY_CODE.BRAZIL:
        this.code = 'BRL';
        this.withDecimals = true;
        break;
      case COUNTRY_CODE.ARGENTINA:
        this.code = 'ARS';
        break;
      case COUNTRY_CODE.CHILE:
        this.code = 'CLP';
        break;
      case COUNTRY_CODE.COLOMBIA:
        this.code = 'COP';
        break;
      case COUNTRY_CODE.ECUADOR:
        this.code = 'USD';
        this.withDecimals = true;
        break;
      case COUNTRY_CODE.VENEZUELA:
        this.code = 'VEF';
        break;
      case COUNTRY_CODE.PERU:
        this.code = 'PEN';
        this.withDecimals = true;
        break;
    }

    this.currencyModel = {
      currency: getCurrencySymbol(this.code, 'narrow', this.locale),
      symbol: this.withDecimals ? '1.2-2' : '1.0-0',
      symbolNoPrice: this.withDecimals ? '4.2-2' : '4.0-0',
    };

    return this.currencyModel;
  }
}

export class currencyModel {
  'currency': string;
  'symbol': string;
  'symbolNoPrice': string;
}
